var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-cancel") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Booking",
    transform: "translate(-201.000000, -674.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(155.000000, 103.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(26.000000, 134.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 412.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-cancel",
    transform: "translate(20.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,30 C23.2842712,30 30,23.2842712 30,15 C30,6.71572875 23.2842712,0 15,0 C6.71572875,0 0,6.71572875 0,15 C0.00895605952,23.2805587 6.71944131,29.9910439 15,30 Z",
    id: "Shape",
    fill: "#D8248A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0090318,9.27179382 L11.1093459,9.36185567 L15,13.252 L18.8906541,9.36185567 C19.3731283,8.87938144 20.1553736,8.87938144 20.6378478,9.36185567 C21.0881571,9.81216495 21.1181777,10.5236081 20.7279097,11.0087353 L20.6378478,11.1090494 L16.747,14.999 L20.6381443,18.8906541 C21.1206186,19.3731283 21.1206186,20.1553736 20.6381443,20.6378478 C20.187835,21.0881571 19.4763919,21.1181777 18.9912647,20.7279097 L18.8909506,20.6378478 L15,16.747 L11.1090494,20.6378478 C10.6265752,21.120322 9.8443299,21.120322 9.36185567,20.6378478 C8.91154639,20.1875385 8.88152577,19.4760954 9.27179382,18.9909682 L9.36185567,18.8906541 L13.252,14.999 L9.36215218,11.1090494 C8.87967795,10.6265752 8.87967795,9.8443299 9.36215218,9.36185567 C9.81246146,8.91154639 10.5239046,8.88152577 11.0090318,9.27179382 Z",
    id: "Combined-Shape",
    fill: "#FEFEFE"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancel);
export default __webpack_public_path__ + "static/media/icon-cancel.d31f69f92487698cfdfcdd00dad414e0.svg";
export { ForwardRef as ReactComponent };